<template>
  <house-component type="esf" />
</template>
<script>
import HouseComponent from './list';
export default{
  name: 'SaleList',
  components: {
    HouseComponent
  }
}
</script>